import {
  TLHF,
} from '../../../../../constants';
import {
  CheckBox,
  TextBox,
} from '../../../../../components';
import { Regist } from '../Regist';

/**
 * 화면 > 상세 > 탭 - 검사이력정보 > 테이블
 * @window w_tb_e601_sulchi
 * @category 설치현장등록
 */
export const RegistTabTableCheckHeader: TLHF<any, Regist> = () => ([
  {
    id: 'equpcd',
    text: '코드',
    width: 10,
    render: (x) => (
      <TextBox
        value={x.equpcd}
        readonly={true}
        transparent={true}
        textAlign="center"
      />
    ),
  },
  {
    id: 'equpnm',
    text: '호기명',
    width: 30,
    render: (x) => (
      <TextBox
        value={x.equpnm}
        readonly={true}
        transparent={true}
        textAlign="left"
      />
    ),
  },
  {
    id: 'contyn',
    text: '계약',
    width: 10,
    render: (x, rowUpdate) => (
      <CheckBox
        value={x.contyn === '1'}
        onChange={(value) => rowUpdate({ contyn: value ? '1' : '0' })}
      />
    ),
  },
]);
